import styled from "styled-components"

export default styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  vertical-align: top;
  margin-bottom: ${({theme}) => theme.spacing.two};
  margin-right: ${({theme}) => theme.spacing.two};
`
